import React from "react";

const ArrowUp = () => (
  <svg width="7" height="6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.82.407a.3.3 0 01.509 0L6.07 4.79a.3.3 0 01-.255.459H.332a.3.3 0 01-.254-.46L2.82.408z" fill="#B8BEC8" />
  </svg>
);

export default ArrowUp;
